import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

const getDocumentFilterStatuses = (
  cityIds: number[],
  documentTypes: number[],
): Promise<AxiosResponse> => {
  return api.get(
    `/documents/filters/statuses/?city_ids=${cityIds.join(',')}&document_types=${documentTypes}`,
  );
};

const getDocumentFilterCategories = (
  cityIds: number[],
  documentTypes: number[],
): Promise<AxiosResponse> => {
  return api.get(
    `/documents/filters/categories/?city_ids=${cityIds.join(',')}&document_types=${documentTypes}`,
  );
};

const getDocumentFilterTypesByState = (stateCode: string): Promise<AxiosResponse> => {
  return api.get(`/v2/documents/filters/types/?state_code=${stateCode}`);
};

const getDocumentFilterStatusesByState = (
  stateCode: string,
  documentTypes: number[],
): Promise<AxiosResponse> => {
  return api.get(
    `/v2/documents/filters/statuses/?state_code=${stateCode}&document_types=${documentTypes}`,
  );
};

const getDocumentFilterCategoriesByState = (
  stateCode: string,
  documentTypes: number[],
): Promise<AxiosResponse> => {
  return api.get(
    `/v2/documents/filters/categories/?state_code=${stateCode}&document_types=${documentTypes}`,
  );
};

export default {
  getDocumentFilterStatuses,
  getDocumentFilterCategories,
  getDocumentFilterTypesByState,
  getDocumentFilterStatusesByState,
  getDocumentFilterCategoriesByState,
};
